'use client';
import * as React from 'react';
import { Combobox } from '@base-ui/react/combobox';
import { ListVirtualizer } from '@base-ui/react/list-virtualizer';
import styles from './index.module.css';

export default function ExampleVirtualizedCombobox() {
  return (
    <Combobox.Root items={virtualizedItems} itemToStringLabel={getItemLabel}>
      <label className={styles.Label}>
        Search 10,000 items
        <Combobox.Input className={styles.Input} />
      </label>

      <Combobox.Portal>
        <Combobox.Positioner className={styles.Positioner} sideOffset={4}>
          <Combobox.Popup className={styles.Popup}>
            <Combobox.Empty>
              <div className={styles.Empty}>No items found.</div>
            </Combobox.Empty>
            <Combobox.List className={styles.List}>
              <ListVirtualizer
                className={styles.Scroller}
                getItemKey={(item) => item.id}
                overscanPx={640}
              >
                {(item: DemoItem) => (
                  <Combobox.Item value={item} className={styles.Item}>
                    <Combobox.ItemIndicator className={styles.ItemIndicator}>
                      <CheckIcon />
                    </Combobox.ItemIndicator>
                    <span className={styles.ItemText}>{item.name}</span>
                  </Combobox.Item>
                )}
              </ListVirtualizer>
            </Combobox.List>
          </Combobox.Popup>
        </Combobox.Positioner>
      </Combobox.Portal>
    </Combobox.Root>
  );
}

function CheckIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      {...props}
      style={{ display: 'block', ...props.style }}
    >
      <path d="m2.5 8.5 4 4 7-9" />
    </svg>
  );
}

interface DemoItem {
  id: string;
  name: string;
}

function getItemLabel(item: DemoItem | null) {
  return item ? item.name : '';
}

const virtualizedItems: DemoItem[] = Array.from({ length: 10000 }, (_, index) => {
  const id = String(index + 1);
  const indexLabel = id.padStart(4, '0');
  return { id, name: `Item ${indexLabel}` };
});
